var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Chuyển đổi dữ liệu điểm danh sang V4",
        visible: _vm.dialogVisible,
        width: "650px",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "section",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isLoading,
              expression: "isLoading",
            },
          ],
        },
        [
          _c(
            "div",
            { staticClass: "shift-card" },
            [
              _c("div", { staticClass: "card-sub-title" }, [
                _c("i", { staticClass: "el-icon-s-operation" }),
                _vm._v(" Thông tin chuyển đổi\n      "),
              ]),
              _c(
                "el-form",
                {
                  ref: "migrateForm",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-position": "top",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Trường", prop: "idSchool" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "Chọn trường", filterable: "" },
                          model: {
                            value: _vm.form.idSchool,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "idSchool", $$v)
                            },
                            expression: "form.idSchool",
                          },
                        },
                        _vm._l(_vm.schoolList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              value: item.id,
                              label: item.id + " - " + item.schoolName,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Từ ngày", prop: "fromDate" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  placeholder: "Chọn ngày bắt đầu",
                                  format: "dd/MM/yyyy",
                                  "value-format": "yyyy-MM-dd",
                                },
                                model: {
                                  value: _vm.form.fromDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "fromDate", $$v)
                                  },
                                  expression: "form.fromDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Đến ngày", prop: "toDate" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  placeholder: "Chọn ngày kết thúc",
                                  format: "dd/MM/yyyy",
                                  "value-format": "yyyy-MM-dd",
                                },
                                model: {
                                  value: _vm.form.toDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "toDate", $$v)
                                  },
                                  expression: "form.toDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "warning-note" }, [
                _c("i", { staticClass: "el-icon-warning-outline" }),
                _c("span", [
                  _vm._v(
                    "Dữ liệu V4 đã có sẽ bị ghi đè. Không nên chọn khoảng thời gian quá 3 tháng trong 1 lần."
                  ),
                ]),
              ]),
            ],
            1
          ),
          _vm.result !== null
            ? _c("div", { staticClass: "shift-card" }, [
                _c("div", { staticClass: "card-sub-title" }, [
                  _c("i", { staticClass: "el-icon-data-analysis" }),
                  _vm._v(" Kết quả chuyển đổi\n      "),
                ]),
                _c("div", { staticClass: "result-summary" }, [
                  _c("div", { staticClass: "summary-box total" }, [
                    _c("span", { staticClass: "num" }, [
                      _vm._v(_vm._s(_vm.result.totalRecords)),
                    ]),
                    _c("span", { staticClass: "lbl" }, [
                      _vm._v("Tổng bản ghi"),
                    ]),
                  ]),
                  _c("div", { staticClass: "summary-box skipped" }, [
                    _c("span", { staticClass: "num" }, [
                      _vm._v(_vm._s(_vm.result.skippedRecords)),
                    ]),
                    _c("span", { staticClass: "lbl" }, [_vm._v("Bỏ qua ⏭️")]),
                  ]),
                  _c("div", { staticClass: "summary-box success" }, [
                    _c("span", { staticClass: "num" }, [
                      _vm._v(_vm._s(_vm.result.migratedRecords)),
                    ]),
                    _c("span", { staticClass: "lbl" }, [
                      _vm._v("Thành công ✅"),
                    ]),
                  ]),
                  _c("div", { staticClass: "summary-box failed" }, [
                    _c("span", { staticClass: "num" }, [
                      _vm._v(_vm._s(_vm.result.failedRecords)),
                    ]),
                    _c("span", { staticClass: "lbl" }, [_vm._v("Lỗi ❌")]),
                  ]),
                ]),
                _c("div", { staticClass: "result-legend" }, [
                  _c("div", { staticClass: "legend-title" }, [
                    _c("i", { staticClass: "el-icon-info" }),
                    _c("span", [_vm._v("Chú thích")]),
                  ]),
                  _c("div", { staticClass: "legend-item" }, [
                    _c("strong", [_vm._v("Tổng bản ghi:")]),
                    _vm._v(
                      "\n          số bản ghi điểm danh tìm thấy theo trường và khoảng ngày đã chọn.\n        "
                    ),
                  ]),
                  _c("div", { staticClass: "legend-item" }, [
                    _c("strong", [_vm._v("Bỏ qua:")]),
                    _vm._v(
                      "\n          số bản ghi không có dữ liệu điểm danh nên không được chuyển đổi.\n        "
                    ),
                  ]),
                  _c("div", { staticClass: "legend-item" }, [
                    _c("strong", [_vm._v("Thành công:")]),
                    _vm._v(
                      "\n          số bản ghi đã được chuyển đổi sang dữ liệu V4.\n        "
                    ),
                  ]),
                  _c("div", { staticClass: "legend-item" }, [
                    _c("strong", [_vm._v("Lỗi:")]),
                    _vm._v(
                      "\n          số bản ghi không chuyển đổi được, cần kiểm tra và có thể chạy lại.\n        "
                    ),
                  ]),
                  _c("div", { staticClass: "legend-note" }, [
                    _vm._v(
                      "\n          Tổng bản ghi thường bằng Bỏ qua + Thành công + Lỗi.\n        "
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "result-message",
                    class: { "has-error": _vm.result.failedRecords > 0 },
                  },
                  [
                    _c("i", {
                      class:
                        _vm.result.failedRecords > 0
                          ? "el-icon-warning"
                          : "el-icon-success",
                    }),
                    _c("span", [_vm._v(_vm._s(_vm.result.message))]),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: { click: _vm.closeDialog },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _vm._v(" Đóng\n    "),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                size: "medium",
                loading: _vm.isLoading,
              },
              on: { click: _vm.handleMigrate },
            },
            [
              _c("i", { staticClass: "el-icon-refresh" }),
              _vm._v(" Chuyển đổi\n    "),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }